import React from 'react';

import IrregularTag from 'design-system/IrregularTag';

import {
  IrregularActions,
  IrregularCard,
  IrregularInfo,
  IrregularPin,
  IrregularSubtitle,
  IrregularTexts,
  IrregularTitle,
  TechnicalAssistanceButton,
} from './styles';

export type IrregularBaseCardProps = {
  title: string;
  subtitle: string;
  reasons: string[];
  onTechnicalAssistance: () => void;
};

const PinIcon = (): JSX.Element => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

const IrregularBaseCard = ({
  title,
  subtitle,
  reasons,
  onTechnicalAssistance,
}: IrregularBaseCardProps): JSX.Element => (
  <IrregularCard>
    <IrregularInfo>
      <IrregularPin aria-hidden="true">
        <PinIcon />
      </IrregularPin>
      <IrregularTexts>
        <IrregularTitle>{title}</IrregularTitle>
        <IrregularSubtitle>{subtitle}</IrregularSubtitle>
        <IrregularTag reasons={reasons} />
      </IrregularTexts>
    </IrregularInfo>

    <IrregularActions>
      <TechnicalAssistanceButton type="button" onClick={onTechnicalAssistance}>
        Solicitar assistência técnica
      </TechnicalAssistanceButton>
    </IrregularActions>
  </IrregularCard>
);

export default IrregularBaseCard;
